import React from 'react';
import { IonIcon } from '@ionic/react';
import { logoGithub, logoLinkedin, logoDiscord, logoYoutube } from 'ionicons/icons';
import './SocialLinks.css';

/**
 * Single source of truth for Zibby's external/social links.
 * Used by both PublicNav (header) and PublicFooter. Add/replace a URL here
 * and it updates everywhere — never hard-code these links inline again.
 * `footerOnly: true` → rendered only where the consumer passes `footerOnly`
 * (the PublicFooter), never in the header nav.
 */
/**
 * The Discord invite. Exported because the app Header renders its own branded
 * Discord link (Clyde logo, not the IonIcon row) and must not carry a second
 * copy of the URL — an invite that expires has to be replaced in ONE place.
 * Generate replacements with Expire After = Never / Max Uses = No Limit.
 */
export const DISCORD_INVITE_URL = 'https://discord.gg/3B8yMJZn88';

const SOCIAL_LINKS = [
  { id: 'github', href: 'https://github.com/teamy-town', label: 'Teamy on GitHub', icon: logoGithub },
  { id: 'linkedin', href: 'https://www.linkedin.com/company/zibby-dev', label: 'Teamy on LinkedIn', icon: logoLinkedin },
  { id: 'discord', href: DISCORD_INVITE_URL, label: 'Join the Teamy Discord', icon: logoDiscord },
  { id: 'youtube', href: 'https://www.youtube.com/@zibbylabs', label: 'Teamy on YouTube', icon: logoYoutube, footerOnly: true },
];

/**
 * Atomic row of external social icon links.
 * @param {string} [className] context class (e.g. public-footer-socials,
 *   public-nav-socials) for placement/color overrides — the base layout +
 *   hover live in SocialLinks.css.
 * @param {boolean} [footerOnly] include links flagged `footerOnly` (the footer
 *   passes this; the header nav does not, so they show ONLY at the bottom).
 */
const SocialLinks = ({ className = '', footerOnly = false }) => (
  <div className={`social-links ${className}`.trim()}>
    {SOCIAL_LINKS.filter((l) => footerOnly || !l.footerOnly).map(({ id, href, label, icon }) => (
      <a
        key={id}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        className="social-link"
      >
        <IonIcon icon={icon} aria-hidden="true" />
      </a>
    ))}
  </div>
);

export default SocialLinks;
export { SOCIAL_LINKS };
